import { render, staticRenderFns } from "./RatebaseEdit.vue?vue&type=template&id=74d79867&scoped=true&"
import script from "./RatebaseEdit.vue?vue&type=script&lang=js&"
export * from "./RatebaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d79867",
  null
  
)

export default component.exports